import React, { useEffect, useState } from "react";
import { Route, useNavigate, useLocation } from "react-router-dom";
import tokenService from "../../services/token.service";
const ProtectedRoute = (props) => {
  const location = useLocation();
  // console.log(location);
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const checkUserToken = () => {
    const userToken = tokenService.getUser();
    if (!userToken || userToken.access_token === "undefined") {
      setIsLoggedIn(false);
      navigate(`/auth/login?href=${location.pathname}`);
    } else {
      setIsLoggedIn(true);
    }
  };
  useEffect(() => {
    checkUserToken();
  }, [isLoggedIn]);
  return <React.Fragment>{isLoggedIn ? props.children : null}</React.Fragment>;
};
export default ProtectedRoute;
